const styles = theme => ({

  media: {
    backgroundSize: '67px ​auto'
  },
  progress: {
    margin: theme.spacing.unit * 2
  },
  btnDetails: {
    border: '1px solid',
    borderRadius: '1.75rem',
    width: '190px',
    margin: 'auto',
    textTransform: 'initial',
    '&:hover': {
      backgroundColor: '#189A44',
      borderColor: '#189A44',
      color: 'white'
    }
  },
  apiCards: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    paddingInline: '8%'
  },
  card: {
    minWidth: '350px',
    textAlign: 'left',
    marginBottom: '30px',
    boxShadow: 'inset -1px 0 0 0 rgba(0, 0, 0, 0.07)',
    backgroundColor: '#ffffff'
  },
  cardActionArea: {
    width: '100%',
  },
  cardActions: {
    justifyContent: 'center'
  },
  btnCardAction: {
    width: '170px',
    height: '40px',
    borderRadius: '28.8px',
    textDecoration: 'underline',
    color:'#004E98'

  },
  txtFindMore: {
    fontFamily: 'Univia Pro',
    fontSize: '14px',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    fontWeight: 'bold'

  },
  cardContent: {
    padding: '15px',
    borderBottom: '1px solid #80808040',
    minHeight: 150
  },
  link: {

    color: '#015099',
    fontSize: '22px',
    fontFamily: 'Univia Pro',
    textTransform: 'none',
    letterSpacing: '-0.6px',
    textAlign: 'center'
  },
  text: {
    fontFamily: 'Univia Pro',
    fontSize: '14.4px',
    lineHeight: 2,
    letterSpacing: '-0.4px',
    textAlign: 'center',
    color: '#4c5068',
    paddingTop: '10%'
  },
  label: {
    fontSize: '14px'
  }
});

export default styles;
